import { HttpClient } from '@angular/common/http';
//import {  ServerModule,  ServerTransferStateModule, BrowserTransferStateModule } from '@angular/platform-server';
// https://stackoverflow.com/questions/50992232/ngx-translate-not-showing-any-text-in-lazy-loaded-module
import { MissingTranslationHandler, MissingTranslationHandlerParams, TranslateLoader, TranslateModuleConfig } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
//import { Observable, from, of as observableOf } from 'rxjs';
//import * as contentEn from '../../assets/i18n/en.json';
//import * as contentRo from './ro.json';
const RESOURCE_MISSING_PREFIX = "![ ";
const RESOURCE_MISSING_SUFFIX = " ]";
//const TRANSLATIONS = {
//  en: contentEn,
//  //ro: contentRo
//};
//export class TranslateMyLoader implements TranslateLoader {
//  constructor() {}
//
//  getTranslation(lang: string): Observable<Object> {
//    //return observableOf(TRANSLATIONS[lang].default);
//    return from(import(`../../assets/i18n/${lang}.json`));// Error: Can't resolve '../assets/i18n' in 'C:\repos\rv-tracker-app\RV.Tracker.Web\ClientApp\src\app\translate'
//  }
//}
// https://andremonteiro.pt/ngx-translate-angular-universal-ssr/
export function HttpLoaderFactory(http) {
    //return new TranslateMyLoader();
    //const zipUtil = import(`../../assets/i18n/en.json`)
    //  .then(function (value) {
    //    if (value) {
    //    }
    //  });
    //return new TranslateHttpLoader(http);//assets/i18n/en.json
    return new TranslateHttpLoader(http, '/assets/i18n/', '.json?q=20210417');
    //return new TranslateHttpLoader(this.http).getTranslation(lang);
    //return new TranslateHttpLoader(http, '/l10n/', '.json');//http://localhost:4200/l10n/en.json
}
//export class WebpackTranslateLoader implements TranslateLoader {
//  getTranslation(lang: string): Observable<any> {
//    //return observableOf(TRANSLATIONS[lang].default);
//    return from(import(`../../assets/i18n/${lang}.json`));// Error: Can't resolve '../assets/i18n' in 'C:\repos\rv-tracker-app\RV.Tracker.Web\ClientApp\src\app\translate'
//  }
//}
export class RvMissingTranslationHandler {
    handle(params) {
        if (console && console.warn)
            console.warn('MissingTranslationHandler', params);
        var key = '';
        if (params.key) {
            var innerKeys = params.key.split('.');
            if (innerKeys.length) {
                key = innerKeys[innerKeys.length - 1]; //last section is most user friendly
            }
        }
        return RESOURCE_MISSING_PREFIX + (key || params.key) + RESOURCE_MISSING_SUFFIX;
    }
}
const ɵ0 = (HttpLoaderFactory);
export const TRANSLATE_MODULE_CONFIG = {
    loader: {
        provide: TranslateLoader,
        useFactory: ɵ0,
        deps: [HttpClient]
        //useFactory: (TranslateMyLoader),
        //deps: [HttpClient]
        //useFactory: WebpackTranslateLoader
    },
    missingTranslationHandler: { provide: MissingTranslationHandler, useClass: RvMissingTranslationHandler },
};
export class TranslatesModule {
    //Import TranslatesModule in the root AppModule only. Never import TranslatesModule in any other module.
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('TranslatesModule has already been loaded. You should only import TranslatesModule in the AppModule only.');
        }
    }
}
export { ɵ0 };
